import React from 'react';
import { useCalculatorContext } from '@/components/DesignSystem/Subsections/Calculator/contexts';
import Progress from '@/components/DynamicFlow/components/Progress';

interface DegreeLengthProgressProps {
  className?: string;
}

const DegreeLengthProgress: React.FC<DegreeLengthProgressProps> = ({
  className = '',
}) => {
  const { getCalculatorValue } = useCalculatorContext();

  // Get values from calculator context
  const creditsCompleted = Number(getCalculatorValue('creditsCompleted')) || 0;
  const totalCreditsRequired =
    Number(getCalculatorValue('totalCreditsRequired')) || 0;

  // Calculate progress percentage
  const progressPercentage =
    totalCreditsRequired > 0
      ? Math.round((creditsCompleted / totalCreditsRequired) * 100)
      : 0;

  // Ensure progress doesn't exceed 100%
  const displayProgress = Math.min(progressPercentage, 100);

  // Don't render if no total credits are set
  if (totalCreditsRequired === 0) {
    return null;
  }

  return (
    <div className={`bg-primary-25 p-4 rounded-lg ${className}`}>
      <div className='font-body-14 font-bold text-gray-900 mb-3'>
        Current Progress: {displayProgress}%
      </div>
      <Progress variant='bar' progress={displayProgress} />
      <span className='font-body-12 text-gray-600 mt-1 block italic'>
        {creditsCompleted} / {totalCreditsRequired} credits
      </span>
    </div>
  );
};

export default DegreeLengthProgress;
